var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"headline"},[_vm._v("Success!")]),_c('v-card-text',[_vm._v("You payment method has been successfully added")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }